import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import AlarmsHandlingIcon from "../../../components/icons/AlarmsHandlingIcon";
import { FCard } from "../../../components/card";
ChartJS.register(ArcElement, Tooltip, Legend);
export const AlarmsHandlingChart = ({ data, title = "Alarms Acknowledged", }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    // Prepare data for Chart.js
    const chartData = {
        labels: data.map((item) => item.name),
        datasets: [
            {
                data: data.map((item) => item.value),
                backgroundColor: data.map((item) => item.color),
                borderWidth: 0,
                cutout: "0%",
            },
        ],
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
        },
        layout: {
            padding: {
                left: isMobile ? 10 : 20,
                right: isMobile ? 10 : 20,
                top: isMobile ? 10 : 20,
                bottom: isMobile ? 10 : 20,
            },
        },
        elements: {
            arc: {
                borderWidth: 0,
            },
        },
    };
    // Custom plugin to draw percentage labels
    const percentagePlugin = {
        id: "percentageLabels",
        afterDatasetsDraw: (chart) => {
            const { ctx } = chart;
            const meta = chart.getDatasetMeta(0);
            meta.data.forEach((arc, index) => {
                const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;
                const total = data.reduce((sum, item) => sum + item.value, 0);
                if (total === 0)
                    return;
                const percentage = Math.round((data[index].value / total) * 100);
                const midAngle = (startAngle + endAngle) / 2;
                const radius = (outerRadius + innerRadius) / 2;
                const labelX = x + Math.cos(midAngle) * radius;
                const labelY = y + Math.sin(midAngle) * radius;
                ctx.save();
                ctx.fillStyle = "white";
                ctx.font = `bold ${isMobile ? "14px" : "16px"} Arial`;
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.fillText(`${percentage}%`, labelX, labelY);
                ctx.restore();
            });
        },
    };
    return (React.createElement(FCard, null,
        React.createElement(Box, { sx: { p: { xs: 1, sm: 2.5 } } },
            React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: { xs: 2, sm: 3 },
                } },
                React.createElement(AlarmsHandlingIcon, { size: isMobile ? 20 : 28 }),
                React.createElement(Typography, { variant: isMobile ? "subtitle1" : "h6", color: "text.primary" }, title)),
            React.createElement(Box, { sx: {
                    width: "100%",
                    height: { xs: 200, sm: 235 },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                } },
                React.createElement(Doughnut, { data: chartData, options: options, plugins: [percentagePlugin] })),
            React.createElement(Box, { sx: {
                    display: "flex",
                    justifyContent: "center",
                    gap: { xs: 2, sm: 4 },
                    mt: { xs: 1.5, sm: 2 },
                    flexWrap: "wrap",
                } }, data.map((item, index) => (React.createElement(Box, { key: index, sx: { display: "flex", alignItems: "center", gap: 1 } },
                React.createElement(Box, { sx: {
                        width: isMobile ? 10 : 12,
                        height: isMobile ? 10 : 12,
                        borderRadius: "50%",
                        backgroundColor: item.color,
                    } }),
                React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: {
                        fontWeight: 500,
                        fontSize: isMobile ? "12px" : "14px",
                    } }, item.name))))))));
};
